import angular from 'angular';

export default function CommandsRepo($http, appSettings) {
  'ngInject';
  return {
    getCommandsForEquipment: function (equipmentId) {
      return $http.get(appSettings.InReachApiEndpoint + '/equipment/' + equipmentId + '/commands/');
    },
    getCommands: function () {
      return $http.get(appSettings.InReachApiEndpoint + '/commands/');
    },
    getEquipmentCommandHistory: function (equipmentId) {
      var url = appSettings.InReachApiEndpoint + '/equipment/' + equipmentId + '/commands/history';
      return $http.get(url);
    },
    getCommandHistoryItem: function (historyItemId) {
      var url = appSettings.InReachApiEndpoint + '/equipment/commands/history/' + historyItemId;
      return $http.get(url);
    },
    getLatestEquipmentCommandHistory: function (equipmentId, commandName) {
      var url = appSettings.InReachApiEndpoint + '/equipment/' + equipmentId + '/commands/' + commandName + '/latest';
      return $http.get(url);
    },
    getCommandRecords: function (options) {
      var suffix = null;

      if (!options) {
        options = {};
      }

      function appendParam(key, value) {
        if (!suffix) {
          suffix = '?' + key + '=' + value;
        } else {
          suffix += '&' + key + '=' + value;
        }
      }

      if (!angular.isDefined(options.page)) {
        options.page = {
          number: 1,
          size: 20
        };
      }

      if (angular.isDefined(options.page.number)) {
        appendParam('page[number]', options.page.number);
      }

      if (angular.isDefined(options.page.size)) {
        appendParam('page[size]', options.page.size);
      }

      return $http.get(appSettings.InReachApiEndpoint + '/commandRecords/' + suffix);
    },
    executeCommand: function (equipmentId, commandName, params) {
      var body = {
        parameters: params
      };

      var url = appSettings.InReachApiEndpoint + '/equipment/' + equipmentId + '/commands/' + commandName;

      return $http.put(url, body);
    },
    getDevice: function (serialNumber) {
      return $http.get(appSettings.IcebergApiCommandsEndpoint + '/devices/' + serialNumber);
    }
  };
}